<template>
  <section class="all_emp card_style">
    <div class="main_header_style">
      <div class="w-100 d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center gap-3">
          <AddFavDailog v-tooltip.left="$t('add_to_faviorites')" />
          <h4 class="mx-2">
            {{ $t("client_type") }}
          </h4>
        </div>
        <input
          type="text"
          v-model="clientTypeText"
          class="form-control w-50"
          :placeholder="$t('search...')"
          @keyup="clientType_categories((page = 1))"
        />
        <router-link to="/clientTypeAdd" class="PrimaryButton btn"
          ><i class="fa-solid fa-plus"></i> {{ $t("add") +" "+ $t("client_type") }}
        </router-link>
      </div>
    </div>

    <!-- <div class="search-visa my-3">
          <form>
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              class="form-control"
              :placeholder="$t('search...')"
            />
          </form>
        </div> -->

    <div class="row">
      <table class="table" id="VisaTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("Control") }}</th>
          </tr>
        </thead>

        <tbody v-if="loading" class="text-center">
          <tr v-for="clientType in 10" :key="clientType">
            <td v-for="clientType in 3" :key="clientType">
              <Skeleton height="2rem" width="90%" class="mb-2"></Skeleton>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="(insurance, index) in clientType.data" :key="index">
            <td>{{ insurance.id }}</td>
            <td>{{ insurance.title }}</td>
            <td>
              <button
                @click="this.$router.push(`/clientTypeEdit/${insurance.id}`)"
                class="btn btn-success mx-1 w-auto"
              >
                <i class="fa-regular fa-edit"></i>
              </button>
              <button
                @click="deleteclientType(insurance.id, index)"
                class="btn btn-danger mx-1 w-auto"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <pagination
        :data="clientType"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="clientType_categories"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
// import $ from "jquery";
import Skeleton from "primevue/skeleton";
export default {
  name: "allVisa",
  components: {
    pagination,
    AddFavDailog,
    Skeleton,
  },
  data() {
    return {
      clientType: [],
      clientTypeText: "",
      loading: true,
    };
  },
  methods: {
    clientType_categories(page = 1) {
      axios
        .post(`/index_client_types?page=${page}`, {
          word: this.clientTypeText,
        })
        .then(({ data }) => {
          this.clientType = data.data;
          // console.log(this.clientType);
          this.loading = false;
        });
    },
    //delete visa
    deleteclientType(id, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          // let delete_id = this.affiliates.id;
          const fromClick = true;
          axios
            .delete(`/client_types/${id}`, { fromClick })
            .then(({ data }) => {
              if (data.status == true) {
                Swal.fire("", this.$t("success_delete"), "success");
                this.clientType.data.splice(index, 1); // Remove the deleted item from the array
              } else {
                Swal.fire("", data.message, "error");
              }
              return data;
            });
        }
      });
    },
  },
  mounted() {
    this.clientType_categories();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
// @import "./_visa.scss";

.main_header_style {
  align-items: center;
  h4 {
    margin-bottom: 0;
  }
}
.search-visa {
  form {
    position: relative;
    i {
      position: absolute;
      top: 12px;
      right: 15px;
      color: #9ca2ac;
    }
    input {
      padding-right: 40px !important;
    }
  }
}
.text-center {
  text-align: center !important;
}
</style>
